module.exports = __webpack_public_path__ + "static/media/like.933a5149.png";